import { InjectionToken } from '@angular/core';
import { IEnvironment } from './environment.interface';

export const ENVIRONMENT_TOKEN = new InjectionToken<IEnvironment>(
  'environment'
);
export const APP_API_NAME = new InjectionToken<'bardo' | 'nomoh' | 'zap'>(
  'APP_API_NAME'
);
